import leafinset from "../../public/assets/images/dashboard/leafinset.png";
import OTP from "../../public/assets/images/dashboard/OTP-login.svg";

// login
import { Button, Input } from "antd";
import  { useEffect, useState } from "react";
import { useMutation } from "@tanstack/react-query";
import OtpInput from "react-otp-input";
import {  farmerRegisterPost, login } from "../../services/api";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Timer from "./Timer";
import FarmerSelectPage from "../farmer_experts/farmerSelectPage/FarmerSelectPage";
import FarmerPartialRegisteration from "../../features/farmer/presentation/pages/FarmerPartialRegisteration";

const Login = () => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [farmerPartialData, setFarmerPartialData] = useState();
  const [showRegisteration, setShowRegisteration] = useState(false);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [otp, setOtp] = useState("");
  const [showFarmers, setShowFarmers] = useState(false);
  const [farmersData, setFarmersData] = useState([]);

  //useNavigation
  const navigation = useNavigate();
  const [searchParams] = useSearchParams();
  //mutations
  const loginMutation = useMutation(login, {
    onSuccess: () => {
      setShowOtpModal(true);
    },
  });

  useEffect(() => {
    if (localStorage.getItem("profile")) {
      navigation("/");
    }
  }, []);

  const otpVerifyMutation = useMutation(
    farmerPartialData ? farmerRegisterPost : login,
    {
      onSuccess: (data) => {
        if (farmerPartialData) {
          localStorage.setItem(
            "profile",
            JSON.stringify(data?.result?.data?.farmer)
          );
          localStorage.setItem("token", data?.result?.data?.token);
          setShowOtpModal(false);
          navigation("/");
        } else {
          localStorage.setItem("profile", JSON.stringify(data?.profile));
          localStorage.setItem("token", data?.token);
          if (data?.hasAccessFarmers) {
            setShowFarmers(true);
            setShowOtpModal(false);
            setFarmersData(data);
            localStorage.setItem(
              "expertId",
              data?.hasAccessFarmers[0]?.expert?.id
            );
          } else {
            if (searchParams.get("return-to")) {
              navigation(searchParams.get("return-to"));
            } else {
              navigation("/");
            }
          }
        }
      },
    }
  );

  const handleClick = () => {
    loginMutation.mutate({ phoneNumber: phoneNumber });
  };

  const otpHandler = () => {
    setShowOtpModal(false);
    setOtp("");
  };

  useEffect(() => {
    if (otp.length === 4) {
      otpVerifyMutation.mutate(
        farmerPartialData
          ? { ...farmerPartialData, otpCode: otp }
          : { phoneNumber: phoneNumber, otpCode: otp }
      );
    }
  }, [otp]);

  const autoFocusNumber = (objectEvent) => {
    setPhoneNumber(objectEvent.target.value);
    if (objectEvent.target.value.length === 11) {
      document.getElementById("confirmCode").focus();
    }
  };

  return (
    <div className="flex flex-row w-full h-[100vh] overflow-hidden items-center justify-between px-[6vw] agrobg gap-16">
      <img
        alt="background-leaf"
        className="absolute h-[100vh] z-0 right-0"
        src={leafinset}
      />

      <div className="Loginform hover:translate-y-[-5px] duration-700 flex flex-col justify-center items-center w-[50vw] max-lg:w-full z-0">
        {showOtpModal ? (
          <>
            <div className="EnterOTP flex flex-col justify-center items-center rounded-[40px] neo overflow-hidden bg-[#E9F0F7]">
              <div className="Backgreen flex flex-col justify-center items-center rounded-[60px] max-lg:w-[92vw] px-9 py-14 gap-8 max-lg:gap-8">
                <p className=" text-center text-agroyar text-[54px] max-lg:text-[2rem] font-bold">
                  ورود به اگرویار
                </p>

                <div className="flex flex-col w-[420px] gap-3">
                  <p className="text-center text-[#6C6C6C] text-[13px] font-medium">
                    کاربر گرامی لطفا کد ارسالی به شماره زیر را وارد نمایید.
                  </p>
                  <p className="text-center text-[#6C6C6C] text-[21px] font-medium">
                    {phoneNumber}
                  </p>
                </div>

                <div className="flex flex-col items-center justify-center gap-10">
                  <div
                    id="5"
                    dir="ltr"
                    className="flex flex-col gap-3 items-end"
                  >
                    <label className="text-right">:کد تایید</label>

                    <OtpInput
                      value={otp}
                      onChange={(objectEvent) => setOtp(objectEvent)}
                      shouldAutoFocus={true}
                      numInputs={4}
                      inputType="number"
                      renderSeparator={<span style={{ width: "16px" }}> </span>}
                      inputStyle={{
                        direction: "ltr",
                        border: "1px solid transparent",
                        borderRadius: "60px",
                        boxShadow:
                          "-5px -5px 18px 0px #FFF inset, 4px 4px 16px 0px rgba(138, 155, 189, 0.48) inset, 7px 7px 18px 0px rgba(255, 255, 255, 0.50) inset, -7px -7px 18px 0px rgba(138, 155, 189, 0.10) inset",
                        width: "47px",
                        height: "68px",
                        fontSize: "35px",
                        color: "#333333",
                        outline: "none",
                        fontWeight: "400",
                        caretColor: "#E7EDF3",
                      }}
                      renderInput={(props) => (
                        <Input autoComplete="nope" {...props} />
                      )}
                    />
                  </div>
                  <Button
                    loading={otpVerifyMutation?.isLoading}
                    disabled={otp.length !== 4}
                    className={`agrobg neo outline-none h-14 hover:!brightness-[1.02] ${
                      otp.length === 4 ? `hover:!text-[#008b45bb]` : ""
                    } text-agroyar rounded-[60px] border-none py-3 px-[134px] !font-body text-2xl font-semibold`}
                    onClick={() =>
                      otpVerifyMutation.mutate({
                        phoneNumber: phoneNumber,
                        otpCode: otp,
                      })
                    }
                  >
                    ورود
                  </Button>
                </div>

                <div className="Frame1048 flex-col justify-center items-center gap-2 flex">
                  <p
                    className=" text-center text-green-700 text-base font-semibold cursor-pointer hover:brightness-125"
                    onClick={otpHandler}
                  >
                    ویرایش شماره همراه
                  </p>

                  <Timer handleClick={handleClick} />
                </div>
              </div>
            </div>
          </>
        ) : showFarmers ? (
          <FarmerSelectPage
            phoneNumber={phoneNumber}
            otp={otp}
            farmersData={farmersData}
          />
        ) : showRegisteration ? (
          <FarmerPartialRegisteration
            setShowOtpModal={setShowOtpModal}
            setPhoneNumber={setPhoneNumber}
            setFarmerPartialData={setFarmerPartialData}
          />
        ) : (
          <>
            <div className="EnterphoneNumber flex flex-col justify-center items-center rounded-[40px] neo overflow-hidden agrobg ">
              <div className="Backgreen flex flex-col justify-center items-center rounded-[60px] max-lg:w-[92vw] px-16 py-20 max-lg:py-16 gap-10 max-lg:gap-6">
                <p className=" text-center text-agroyar text-[54px] max-lg:text-[2rem] font-bold">
                  ورود به اگرویار
                </p>

                <p className=" text-center w-[274px] max-lg:w-[300px] max-lg:text-[11px] text-[#6c6c6c] text-[13px] font-medium">
                  لطفا برای دسترسی به بخش های مختلف سایت شماره تلفن همراه خود را
                  وارد کنید.
                </p>

                <div className="Borderdashded flex flex-col justify-center items-center gap-6">
                  <Input
                    autoComplete="nope"
                    className="Numberinput flex font-bold text-center tracking-widest text-[18px] font-body max-lg:w-[300px] w-[363px] h-12 px-8 py-3 bg-gradient-to-tl from-white to-slate-100 rounded-3xl shadow-inner border border-slate-100 justify-end items-center gap-2.5 "
                    value={phoneNumber}
                    onChange={autoFocusNumber}
                    placeholder="شماره همراه"
                    width="360px"
                    rwidth="100%"
                    type="number"
                    name="phoneNumber"
                  />
                </div>

                <Button
                  id="confirmCode"
                  loading={loginMutation?.isLoading}
                  onClick={() =>
                    loginMutation.mutate({ phoneNumber: phoneNumber })
                  }
                  className="agrobg neo h-14 rounded-[60px] outline-none border-none py-3 hover:!text-green-600 hover:!brightness-[1.02] px-[82px] text-agroyar !font-body text-2xl font-semibold"
                >
                  ارسال کد تایید
                </Button>

                <div className=" w-64 text-center text-neutral-500 text-xs font-medium block">
                  استفاده از اگرویار به معنای تایید و پذیرش{" "}
                  <Link to="https://agroyaar.com/terms">
                    <span className="text-green-700 text-xs font-medium hover:brightness-125 ">
                      قوانین و مقررات
                    </span>
                  </Link>{" "}
                  و{" "}
                  <Link to="https://agroyaar.com/privacy">
                    <span className="text-green-700 text-xs font-medium hover:brightness-125 ">
                      شرایط حریم خصوصی
                    </span>
                  </Link>{" "}
                  این پلتفرم می‌باشد.
                </div>

                {/* <div className="flex flex-col justify-center items-center gap-2 text-neutral-500 text-xs font-medium">
                  تا کنون در اگرویار ثبت نام نکرده اید؟
                  <span
                    className="text-green-700 mr-3 text-base font-medium hover:brightness-125 cursor-pointer"
                    onClick={setShowRegisteration}
                  >
                    ثبت نام کشاورز
                  </span>
                </div> */}
              </div>
            </div>
          </>
        )}
      </div>

      <img
        alt="otp"
        className=" max-lg:hidden hover:scale-95 duration-700 w-[45vw] h-[45vw] z-10 "
        src={OTP}
      />
    </div>
  );
};

export default Login;
